import { FC, useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import { TENGE_LABEL } from '@/common/constants/common';
import {
  LOAN_AMOUNT_CHANGE_STEP,
  LOAN_AMOUNT_INITIAL_VALUE,
  LOAN_AMOUNT_MAX_VALUE,
  LOAN_AMOUNT_MIN_VALUE,
} from '@/common/constants/loan';
import { AppContext } from '@/common/hooks/useAppContext';
import { formatAmount } from '@/common/utils/formatNumber';
import { SliderWidget } from '@/components/SliderWidget';
import { CardBlank } from '@/shared/CardBlank';
import { MainButton } from '@/shared/MainButton';

interface CalculatorOfferProps {
  className?: string;
}

export const CalculatorWidget: FC<CalculatorOfferProps> = ({ className }) => {
  const { requestedLoanAmount, setAmount: setAmountContext } =
    useContext(AppContext);
  const navigate = useNavigate();

  const initialAmount =
    isFinite(Number(requestedLoanAmount)) && Number(requestedLoanAmount) > 0
      ? Number(requestedLoanAmount)
      : LOAN_AMOUNT_INITIAL_VALUE;

  const [amount, setAmount] = useState<number>(initialAmount);

  const handleLoanAmount = (value: number) => {
    setAmount(value);
    setAmountContext(String(value));
  };

  const onSubmit = () => {
    navigate('/auth');
  };

  return (
    <CardBlank className={`${className} ${styles.calculatorWrapper}`}>
      <h4 className={styles.title}>
        <FormattedMessage defaultMessage="Калькулятор микрокредитов" />
      </h4>
      <SliderWidget
        handler={handleLoanAmount}
        minValue={LOAN_AMOUNT_MIN_VALUE}
        maxValue={LOAN_AMOUNT_MAX_VALUE}
        step={LOAN_AMOUNT_CHANGE_STEP}
        initialValue={amount}
        label={TENGE_LABEL}
        hasDisplay={false}
      />
      <MainButton
        id="home-page-calculator-get-money"
        text={<FormattedMessage defaultMessage="Получить деньги" />}
        onClick={onSubmit}
      />
      <div className={styles.totalBlock}>
        <div className={styles.textRow}>
          <span>
            <FormattedMessage defaultMessage="Запрашиваемая сумма:" />
          </span>
          <span className="font-bold">
            <span>{formatAmount(amount)}</span>
            <span> {TENGE_LABEL}</span>
          </span>
        </div>
      </div>
    </CardBlank>
  );
};
